import { Button, Modal, Select, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { ModalTitle } from '../../components/text/Titles';

interface Props {
  visible: boolean;
  username: string;
  roleIn: string;
  onSubmit: (username: string, role: string) => any;
  onCancel: () => void;
}

const ChangeRole = ({ visible, onSubmit, onCancel, username, roleIn }: Props) => {
  const [role, setRole] = useState<string>('USER');

  useEffect(() => {
    setRole(roleIn);
    return () => {
      setRole('USER');
    };
  }, [roleIn]);

  const handleOk = () => {
    onSubmit(username, role);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      title={<ModalTitle>Change user role</ModalTitle>}
      onCancel={handleCancel}
      visible={visible}
      footer={
        <div className="text-right">
          <Button type="default" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleOk}>
            Save
          </Button>
        </div>
      }>
      <Form>
        <Form.Item label="Role">
          <Select value={role} onChange={(value: string) => setRole(value)}>
            {['ADMIN', 'USER'].map(role => (
              <Select.Option key={role} value={role}>
                {role}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangeRole;
